import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Eyebrow } from '#app/components/typography/eyebrow.tsx'
import { H1 } from '#app/components/typography/h1.tsx'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Lead',
}

const component: componentProps = {
	name: 'Eyebrow',
	shortName: 'Eyebrow',
	fileName: 'eyebrow',
	category: 'typography',
	description: [
		"An headline's eyebrow comes second in the typographic hierarchy and sits above the main headline (like your eyebrow sits above your eye). These eyebrow headlines are usually keyword labels that help users understand the theme of the content they're about to read.",
	],
	features: ['Labels the content of a section or page.', "Opts-in to your design system's typographic styles."],
	parts: [
		{
			name: 'eyebrow',
			description:
				"An headline's eyebrow comes second in the typographic hierarchy and sits above the main headline (like your eyebrow sits above your eye). These eyebrow headlines are usually keyword labels that help users understand the theme of the content they're about to read.",
			props: [],
			state: [],
			events: [],
			layout: [],
			accessibility: [],
		},
	],
	usage: `<div className="bg-muted-100 rounded-lg p-4">
	<Eyebrow>Typography</Eyebrow>
	<H1>Typography is complex</H1>
	<P>
		An headline's eyebrow comes second in the typographic hierarchy and sits above the main headline (like your eyebrow sits above your eye). These eyebrow headlines are usually
		keyword labels that help users understand the theme of the content they're about to read.
	</P>
</div>`,
	styling: `.eyebrow {
	@apply text-muted-400 mb-4 max-w-prose text-xs font-sans font-medium uppercase tracking-wider;
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const TextRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<div className="bg-muted-100 rounded-lg p-4">
				<Eyebrow>Typography</Eyebrow>
				<H1>Typography is complex</H1>
				<P>
					An headline's eyebrow comes second in the typographic hierarchy and sits above the main headline (like your eyebrow sits above your eye). These eyebrow headlines are usually
					keyword labels that help users understand the theme of the content they're about to read.
				</P>
			</div>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default TextRoute
